/**
 * Created by jerome on 15/10/2018.
 */
import Animation from '../../core/Animation'
import NSSSVGAnimator from '../../core/NSSSVGAnimator'
const toValue = function (value, target, magnetism) {
  return value + (target - value) * magnetism
}

let start
let pixel, vx=1, vy=1, alpha, node
export default class OutParticlesDisjoint extends Animation {
  constructor (pixelDatas, options, onUpdate, onComplete) {
    super(onUpdate, onComplete)
    this._pixelDatas = pixelDatas
    this._xOffset = options.xOffset | 0
    this._yOffset = options.yOffset | 0
    this._scaleNoise = options.scaleNoise | 8
    this._force = options.force | 2
    this._wave = options.wave | 10
    this._duration = options.duration | 50
    this._pixelSize = options.pixelSize | 1
    this._renderScale = options.renderScale || 1
    this._magnetism = options.magnetism? options.magnetism : .05
    const initVel = options.initMaxVel? options.initMaxVel : 1
    const initVelHalf = initVel / 2
    let node = this._pixelDatas.particles.head
    let pixel
    while (node) {
      pixel = node.data
      pixel.x = pixel.sx
      pixel.y = pixel.sy
      pixel.velX = Math.random()*initVel - initVelHalf
      pixel.velY = Math.random()*initVel - initVelHalf
      // 0 is cool
      pixel.life = Math.random() * (this._duration - 6) + 3
      pixel.visible = true

      node = node.next
    }
    this._t = Math.random() * 40
    //this.frameTime = 0
    this._noise = NSSSVGAnimator.getNoise()
  }

  update (ctx) {
    //start = Date.now()
    this.updateIn()

    node = this._pixelDatas.particles.head


    while (node) {
      pixel = node.data
      if (pixel.visible) {
        //   if(p.visible && (p.id+swapPair) & 1){
        alpha = 1 - this._time / pixel.life
        if (alpha < 0) {
          pixel.visible = false
        } else {
          vx = (this._noise.noise2D((pixel.x / 600* this._scaleNoise), (pixel.y / 600* this._scaleNoise))  ) * this._wave
          vy = (this._noise.noise2D((pixel.x / 600 * this._scaleNoise + this._t ), (pixel.y / 600* this._scaleNoise))  ) * this._wave
          //  vx = (NSSSVGAnimator.getNoise().noise2D((pixel.x / this._pixelDatas.bounds[2] * this._scaleNoise), (pixel.y / this._pixelDatas.bounds[3] * this._scaleNoise)) * 0.5 ) * this._wave
         // vy = (NSSSVGAnimator.getNoise().noise2D((pixel.x / this._pixelDatas.bounds[2] * this._scaleNoise + this._t ), (pixel.y / this._pixelDatas.bounds[3] * this._scaleNoise)) * 0.5 ) * this._wave


          pixel.velX = toValue(pixel.velX, vx, this._magnetism)
          pixel.velY = toValue(pixel.velY, vy, this._magnetism)
          ctx.globalAlpha = alpha
          ctx.fillRect(
            pixel.x * this._renderScale + this._xOffset,
            pixel.y * this._renderScale + this._yOffset,
            this._pixelSize * this._renderScale,
            this._pixelSize * this._renderScale
          )
          pixel.x += pixel.velX * this._force
          pixel.y += pixel.velY * this._force
        }
      }
      node = node.next
    }

    this.updateOut()
    //this.frameTime = Date.now()-start
  }

}
